/**
 * @generated SignedSource<<7760cf85204e07c69fe284dd00637bf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentUpdatedDateContent$data = {
  readonly updatedDate: number | null | undefined;
  readonly " $fragmentType": "contentUpdatedDateContent";
};
export type contentUpdatedDateContent$key = {
  readonly " $data"?: contentUpdatedDateContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentUpdatedDateContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentUpdatedDateContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedDate",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "efc4ff769342d6d99d1e8fb1f64dc490";

export default node;
